function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.33087 0.0917681C7.97462 -0.167639 9.65796 0.126995 11.1159 0.929284C12.5738 1.73157 13.7235 2.99595 14.384 4.52336C15.0444 6.05077 15.1782 7.75447 14.7641 9.36622C14.3501 10.978 13.4117 12.4063 12.0968 13.4262C10.782 14.4461 9.16521 14.9998 7.50111 15.0001L7.50098 14.1177L7.50239 15.0001L7.50111 15.0001C6.22339 15.0019 4.96903 14.6759 3.85684 14.0566L3.48768 13.8369C3.60883 13.9138 3.73194 13.9871 3.85684 14.0566L1.16236 14.9548C0.845305 15.0605 0.495746 14.978 0.259423 14.7416C0.0231008 14.5053 -0.0594189 14.1558 0.0462677 13.8387L0.94458 11.1438C1.01391 11.2685 1.08694 11.3915 1.16362 11.5126L0.94458 11.1438C0.208985 9.82039 -0.110496 8.3019 0.0338886 6.78801C0.191882 5.13143 0.896328 3.57444 2.03632 2.36217C3.17632 1.14989 4.68712 0.351175 6.33087 0.0917681ZM10.2651 2.47535C9.15021 1.86184 7.86294 1.63653 6.60596 1.8349C5.34897 2.03327 4.19366 2.64405 3.3219 3.57109C2.45013 4.49812 1.91144 5.68876 1.79062 6.95555C1.6698 8.22235 1.97372 9.49335 2.65453 10.5685C2.79631 10.7924 2.82995 11.0681 2.74615 11.3195L2.27846 12.7226L3.68152 12.2549C3.93325 12.171 4.20938 12.2048 4.43341 12.347C5.3501 12.9289 6.41381 13.2371 7.49958 13.2354L7.50085 13.2354C8.77339 13.2352 10.0097 12.8118 11.0152 12.0318C12.0207 11.2519 12.7383 10.1596 13.0549 8.92713C13.3715 7.69461 13.2693 6.39178 12.7642 5.22376C12.2591 4.05574 11.38 3.08887 10.2651 2.47535Z",
  fill: "currentColor"
});
const SvgChatIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChatIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chatIcon.3132023e.svg";
export { ForwardRef as ReactComponent };